export default {
  zh: {
    title: '赠送金币',
    record: '记录',
    nowgold: '当前账号可用金币数量: ',
    pleaseinput: '请输入要赠送的账号id：',
    pleaseinputgolds: '请选择要赠送的金币数量：',
    sure: '确定赠送',
    sendbtn: '赠送',
    title2: '赠送记录',
    recuid: '请输入受赠人id',
    goldnum: '请输入金币数量',
    nogold: '当前账号金币不足',
    sendsuccess: '赠送成功',
    sendtime: '赠送时间',
    senduser: '接收人',
    sendnum: '金币数量',
    comment: '确定',
    nouser: '用户不存在',
    madesure: '确定给用户AAA赠送BBB金币吗?',
    cannot: '对方为代理，不可充值',
    cancel: '取消'
  },
  en: {
    title: 'Present coins',
    record: 'Record',
    nowgold: 'You have gold:',
    pleaseinput: 'Please enter the account ID:',
    pleaseinputgolds: 'Please select the gold number:',
    sure: 'Present',
    sendbtn: 'Present',
    title2: 'Record',
    recuid: 'Please enter the account ID',
    goldnum: 'Please enter the gold number',
    nogold: 'Gold coins are not enough',
    sendsuccess: 'Success',
    sendtime: 'Time',
    senduser: 'receive user',
    sendnum: 'gold',
    comment: 'confirm',
    nouser: 'user not exist',
    madesure: 'Are you sure you want to present \nBBB gold coins to the user AAA',
    cannot: 'This user is agent. Recharge is not available',
    cancel: 'cancel'
  },
  ar: {
    title: 'ارسال عملات ذهبية',
    record: 'سجل',
    nowgold: 'عدد العملات الذهبية المتاحه في الحساب الان',
    pleaseinput: 'من فضلك ادخل الاي دي الذي يود ارسال العملات الذهبية ',
    pleaseinputgolds: 'من فضلك ادخل عدد العملات الذهبية التي تود ارسالها',
    sure: 'تاكيد الارسال',
    sendbtn: 'ارسال',
    title2: 'سجل المرسلات',
    recuid: 'من فضلك ادخل الاي دي المستلم',
    goldnum: 'من فضلك ادخل عدد العملات الذهبيه',
    nogold: 'العملات الذهبية في الحساب غير كافية',
    sendsuccess: 'نجحت عملية الارسال',
    sendtime: 'وقت الارسال',
    senduser: 'المرسل',
    sendnum: 'عدد العملات الذهبيه',
    comment: 'تاكيد',
    nouser: 'المستخدم غير موجود',
    madesure: 'هل تريد تاكيد ارسال \nBBB عملة ذهبية الي المستخدم AAA ؟',
    cannot: 'هذا المستخدم وكيل فلا يمكن الشحن له',
    cancel: 'ألغيت'
  },
  tr: {
    title: 'Altın gönder',
    record: 'Geçmiş',
    nowgold: 'Bu hesaptaki kullanılabilen altın miktarı: ',
    pleaseinput: 'Lütfen göndermek istediğiniz hesap id nuramasını girin:',
    pleaseinputgolds: 'Lütfen göndermek istediğiniz altın miktarını girin:',
    sure: 'Gönder',
    sendbtn: 'Altın gönder',
    title2: 'Gönderme geçmişi',
    recuid: 'Lütfen hediye etmek istediğiniz kişinin id numarasını girin',
    goldnum: 'Lütfen altın miktarını girin',
    nogold: 'Bu hesapta yeterli altın yok',
    sendsuccess: 'Başarıyla hediye ettiniz',
    sendtime: 'Zaman',
    senduser: 'Alıcı',
    sendnum: 'Altın miktarı',
    comment: 'Onayla',
    nouser: 'Kullanıcı bulunmadı',
    madesure: 'AAA kullanıcıya BBB altın göndereceğinizden emin misiniz?',
    cannot: 'Kullanıcı altın ajansıdır. Çekim yapılamaz.',
    cancel: 'İptal et'
  }
}



// WEBPACK FOOTER //
// src/pages/app/agentgold/lang.js